export const ROUTES = {
    SIGN_UP: '/signup',
    SIGN_IN: '/signin',
    BOARDS: '/boards',
    BOARDS_GROUP: '/boardsgroup',
    BOARDS_GROUPS: '/boardsgroup/:boards_group',
    BOARD: '/boards/:board',
    MYPROFILE: '/myProfile',
    WELCOME: '/Welcome'
};
